import { Typography } from "@mui/material";
import { useAuth } from "../../providers/AuthProvider";
import { usePermissions } from "../../providers/PermissionsProvider";
import Dashboard from "../Dashboard";

export default function Home() {
    const { homeArea, isFetchingPermissions } = usePermissions();
    const { signOut } = useAuth();

    if (isFetchingPermissions) {
        return (
            <Typography>
                Carregando...
            </Typography>
        );
    }

    if (homeArea === '0' || homeArea === 0) {
        signOut();
        return null;
    }

    return <Dashboard />;
}
